module.exports = __webpack_public_path__ + "static/media/kimber_schlegelmilch.988aa07b.png";